import InstallObjectsIcon from './component'

export default InstallObjectsIcon
